import { useCallback, useEffect, useState } from 'react';
import { usePortalCmsRefresh } from '../../context/RealtimeSyncContext';

export const usePortalContent = (slug) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchContent = useCallback(async () => {
    if (!slug) return;
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/portal-cms/page/${slug}`);
      if (!response.ok) throw new Error('Failed to load portal content');
      const data = await response.json();
      setContent(data.data || null);
      setError(null);
    } catch (err) {
      setError(err.message);
      setContent(null);
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  usePortalCmsRefresh(slug, fetchContent);

  return { content, loading, error, refresh: fetchContent };
};

export const buildPortalFileUrl = (fileUrl) => {
  if (!fileUrl) return '';
  if (fileUrl.startsWith('http')) return fileUrl;
  return `${process.env.REACT_APP_API_BASE_URL}${fileUrl.startsWith('/') ? fileUrl : `/${fileUrl}`}`;
};
